export default "__VITE_ASSET__xQ7fyFO8__"